import styled from '@emotion/styled';

export const NavItem = styled.li`
  list-style: none;
`;
